import { IGetAllChecklistMaquinaEquipItensUseCase } from "../../../presentation/useCases/read/get_all_checklist_maquina_equip_itenss_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ChecklistMaquinaEquipItemModel } from "../../models/checklist_maquina_equip_item";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllChecklistMaquinaEquipItenssUseCase
 */

export class GetAllChecklistMaquinaEquipItensUseCase
  extends BasePaginatedUseCase<ChecklistMaquinaEquipItemModel>
  implements IGetAllChecklistMaquinaEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async execute(
    idChecklistMaquinaEquip: number | null,
    ordem: string | null,
    descricao: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const result = await this.repository.getAllChecklistMaquinaEquipItem(
      idChecklistMaquinaEquip,
      ordem,
      descricao,
      page,
      rowsPerPage,
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
